import { COLUMN_ACTION_TYPE, COLUMN_DATE_TIME, COLUMN_DETAILS, COLUMN_OPERATOR, COLUMN_TYPE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const CertificateAuditColumns: TableColumn[] = [
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 0,
        sortByName: "dateTimeLocal",
        sortDirection: "asc",
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Operator",
        accessor: "operator",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "operator",
        columnId: COLUMN_OPERATOR
    },
    {
        heading: "Action",
        accessor: "action",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "action",
        columnId: COLUMN_ACTION_TYPE
    },
    {
        heading: "Before",
        accessor: "valueOld",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "before",
        columnId: COLUMN_DETAILS
    },
    {
        heading: "After",
        accessor: "valueNew",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "after",
        columnId: COLUMN_DETAILS
    }
]

export default CertificateAuditColumns;
